(function () {
  'use strict';

  var MIN_PEOPLE = 1;
  var MAX_PEOPLE = 80;

  function bp() { return window.BP_DISCOUNT || null; }

  function fmt(n) {
    var d = bp();
    if (d && typeof d.moneyFmt === 'function') return d.moneyFmt(n);
    var parts = (Number(n) || 0).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function pctFor(qty) {
    var d = bp();
    if (d && typeof d.findTierPct === 'function') return d.findTierPct(qty) || 0;
    return 0;
  }

  function floor() {
    var d = bp();
    return d && typeof d.floorPrice === 'number' ? d.floorPrice : 226.98;
  }

  function render(slider) {
    var root = slider.closest('[data-team-slider-root]') || slider.parentNode;
    if (!root) return;

    var n = parseInt(slider.value, 10);
    if (!isFinite(n) || n < MIN_PEOPLE) n = MIN_PEOPLE;
    if (n > MAX_PEOPLE) n = MAX_PEOPLE;

    var pct = pctFor(n);
    var perPerson = floor() * (1 - pct / 100);
    var teamTotal = perPerson * n;

    var atMax = n >= MAX_PEOPLE;
    set(root, 'n', atMax ? (MAX_PEOPLE + '+') : String(n));
    set(root, 'word', n === 1 ? 'person' : 'people');
    set(root, 'pct', pct ? '−' + pct + '%' : '0%');
    setHTML(root, 'pp', '<em>' + fmt(perPerson) + '</em>');
    setHTML(root, 'tot', '<em>' + fmt(teamTotal) + '</em>');

    slider.setAttribute('aria-valuenow', String(n));
    slider.setAttribute('aria-valuetext', (atMax ? (MAX_PEOPLE + ' or more') : n) + (n === 1 ? ' person' : ' people')
      + (pct ? ', ' + pct + ' percent group discount' : ''));
  }

  function set(root, key, txt) {
    var els = root.querySelectorAll('[data-ts="' + key + '"]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }
  function setHTML(root, key, html) {
    var els = root.querySelectorAll('[data-ts="' + key + '"]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].innerHTML !== html) els[i].innerHTML = html;
    }
  }

  function wire(slider) {
    if (slider.dataset.bpTeamWired) return;
    slider.dataset.bpTeamWired = '1';
    slider.addEventListener('input', function () { render(slider); });
    slider.addEventListener('change', function () { render(slider); });
    render(slider);
  }

  function init() {
    var sliders = document.querySelectorAll('[data-team-slider]');
    if (!sliders.length) return;

    var tries = 0;
    (function waitReady() {
      if (bp() || tries > 40) {
        for (var i = 0; i < sliders.length; i++) wire(sliders[i]);
        return;
      }
      tries++;
      setTimeout(waitReady, 50);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
